module.exports = __webpack_public_path__ + "static/media/Travel.af28f07f.png";